module.exports = __webpack_public_path__ + "media/nopayment@3x.89584584.png";